/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AcceptTermsPayload } from '../models/AcceptTermsPayload';
import type { AccountSettingsResponse } from '../models/AccountSettingsResponse';
import type { EmailOtpCodePayload } from '../models/EmailOtpCodePayload';
import type { EmailPayload } from '../models/EmailPayload';
import type { UpdateAccountSettings } from '../models/UpdateAccountSettings';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SettingsService {
    /**
     * Account Settings
     * @returns AccountSettingsResponse Successful Response
     * @throws ApiError
     */
    public static accountSettingsApiSettingsGet(): CancelablePromise<AccountSettingsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/settings/',
        });
    }
    /**
     * Update Account Settings
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static updateAccountSettingsApiSettingsPatch(
        requestBody: UpdateAccountSettings,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/settings/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Accept Terms
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static acceptTermsApiSettingsAcceptTermsPost(
        requestBody: AcceptTermsPayload,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/settings/accept-terms',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Email Verification
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static createEmailVerificationApiSettingsCreateEmailVerificationPost(
        requestBody: EmailPayload,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/settings/create-email-verification',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                409: `Conflict`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Verify Email
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static verifyEmailApiSettingsVerifyEmailPost(
        requestBody: EmailOtpCodePayload,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/settings/verify-email',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                422: `Validation Error`,
            },
        });
    }
}
